import { CarouselImageVariants, CarouselSectionTypes } from '@dfh-corp-sites/ui'
import React from 'react'

import CarouselSectionEducation from './CarouselSectionEducation'
import CarouselSectionImageSidenav from './CarouselSectionImageSidenav'
import CarouselSectionImageSimple from './CarouselSectionImageSimple'
import CarouselSectionProduct from './CarouselSectionProduct'
import CarouselSectionText from './CarouselSectionText'
import { CarouselSectionProps } from './types'

function CarouselSection({ sliderType, imageVariant, ...props }: CarouselSectionProps) {
  if (sliderType === CarouselSectionTypes.Image) {
    if (imageVariant === CarouselImageVariants.Simple) {
      return <CarouselSectionImageSimple {...props} />
    }

    if (imageVariant === CarouselImageVariants.Sidenav) {
      return <CarouselSectionImageSidenav {...props} />
    }
  }

  if (sliderType === CarouselSectionTypes.Product) {
    return <CarouselSectionProduct {...props} />
  }

  if (sliderType === CarouselSectionTypes.Text) {
    return <CarouselSectionText {...props} />
  }

  if (sliderType === CarouselSectionTypes.Education) {
    return <CarouselSectionEducation {...props} />
  }

  return null
}

export default CarouselSection
